module.exports = __webpack_public_path__ + "static/banner-f341317885d66145a72f79f0183f28ec.jpg";